import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import StyledComponent from '~/components/styledComponentMixins';

const StyledDropdown = StyledComponent(Dropdown);

const CustomizableDataDropdownPropTypes = {
  dropdownProps: PropTypes.object,
  dropdownTag: PropTypes.string,
  isArrayScalar: PropTypes.bool,
  isDropdownWithInput: PropTypes.bool,
  itemClasses: PropTypes.string,
  itemClassNameCallback: PropTypes.func,
  itemsFilterCallback: PropTypes.func,
  onClick: PropTypes.func,
  onClickWithValue: PropTypes.func,
  toggleDisplay: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  toggleClass: PropTypes.string,
  handleSelectOptions: PropTypes.func,
  selectedOptions: PropTypes.array,
  availableOptions: PropTypes.array,
  dropdownFooter: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
  ]),
};

const CustomizableDataDropdownDefaultProps = {
  dropdownFooter: null,
  dropdownProps: {},
  dropdownTag: 'div',
  isArrayScalar: false,
  isDropdownWithInput: true,
  itemClassNameCallback: () => '',
  itemClasses: 'flex start h-space-8 no-wrap',
  itemsFilterCallback: item => item.name,
  onClick: undefined,
  toggleClass: 'clickable-element column-drop-down',
  selectedOptions: [],
  availableOptions: [],
  handleSelectOptions: data => data,
};

const CustomizableDataDropdown = ({
  dropdownProps,
  dropdownTag,
  isArrayScalar,
  isDropdownWithInput,
  itemClassNameCallback,
  itemClasses,
  itemsFilterCallback,
  onClick,
  toggleDisplay,
  toggleClass,
  handleSelectOptions,
  selectedOptions,
  availableOptions,
  dropdownFooter,
  onClickWithValue,
}) => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(prev => !prev);

  const updateData = value => {
    const selectedData = selectedOptions;

    const selectedDataKeys = selectedOptions.map(d => d.prop);
    const currentDataIndex = availableOptions.findIndex(data => data.prop === value);
    const currentDataOption = availableOptions.find(opt => opt.prop === value);
    if (selectedDataKeys.includes(value)) {
      const key = selectedData.findIndex(dataKey => dataKey.prop === value);
      selectedData.splice(key, 1);
    } else {
      selectedData.splice(currentDataIndex, 0, currentDataOption);
    }
    handleSelectOptions(selectedData);
  };

  const handleCheckBox = event => {
    const { value } = event.currentTarget;
    updateData(value);
  };

  return (
    <StyledDropdown
      isOpen={expanded}
      toggle={toggleExpanded}
      {...dropdownProps}
    >
      <DropdownToggle
        className={toggleClass}
        caret={false}
        tag={dropdownTag}
      >
        {toggleDisplay}
      </DropdownToggle>
      <DropdownMenu>
        <div className="main-dropdown-menu">
          {(
            availableOptions.length > 0
              && availableOptions.filter(itemsFilterCallback).map(item => {
                const classNames = itemClassNameCallback(item);
                const prop = isArrayScalar ? item : item.prop;

                return (
                  <DropdownItem
                    className={(itemClasses.concat(
                      classNames.length > 0 ? ` ${classNames}` : '',
                    ))}
                    data-value={prop}
                    divider={false}
                    key={prop}
                    onClick={onClickWithValue
                      ? () => onClickWithValue(prop)
                      : onClick || handleCheckBox}
                    toggle={false}
                    value={prop}
                  >
                    {isDropdownWithInput && (
                      <input
                        type="checkbox"
                        checked={!!selectedOptions.find(selectedOption => (
                          selectedOption.name === item.name
                        ))}
                      />
                    )}
                    <span>{isArrayScalar ? `${item}` : item.name}</span>
                  </DropdownItem>
                );
              })
          )}
        </div>
        {dropdownFooter}
      </DropdownMenu>
    </StyledDropdown>
  );
};

CustomizableDataDropdown.propTypes = CustomizableDataDropdownPropTypes;
CustomizableDataDropdown.defaultProps = CustomizableDataDropdownDefaultProps;

export default CustomizableDataDropdown;
